let utils = require('../../actions/utils');
let { initSelectedParamsFromOrderGroup, saveSelectedParamsGroup } = require('../groups/account/current-order');
let orders = require('../../actions/account/orders');
let currentOrder = require('../../actions/account/current-order');
let customOrder = require('../../actions/custom-order');
let { calcPriceGroup } = require('../groups/order');
let content = require('../../actions/layout/content');

let cities = require('../../actions/custom-order/cities');
let rubrics = require('../../actions/custom-order/rubrics');
let legalEntities = require('../../actions/custom-order/legalEntities');
let purposes = require('../../actions/custom-order/purposes');
let mapClasses = require('../../actions/custom-order/map-classes');
const currentOrderActions = require('../../actions/account/current-order');

let saveFilterValues = [
    content.setIsLoading(true),
    ...saveSelectedParamsGroup,
    currentOrder.updateOrder(['price', 'paymentTypeId', 'necessaryDocuments']),
    content.setIsLoading(false),
    utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false),
    utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'], true)
];

let clearFilters = [
    cities.clearFilter,
    rubrics.clearFilter,
    legalEntities.clearFilter,
    purposes.clearFilter,
    mapClasses.clearFilter
];

module.exports = {
    // onEdit уже не используется, но всегда может вернуться
    onEdit: [
        ...calcPriceGroup,
        utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false),
        utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'], true)
    ],
    onCancel: [
        ...clearFilters,
        content.setIsLoading(true),
        ...initSelectedParamsFromOrderGroup,
        content.setIsLoading(false),
        customOrder.unsetFilterValuesChanged
    ],
    onSave: [
        ...clearFilters,
        utils.unset(['order', 'originalParameters', 'statistic']),
        utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false),
        [
            utils.isLocalEditMode,
            {
                true:[
                    orders.saveLocalChangesFilterValues,
                    currentOrder.updateOrder(['price']),
                    // если сумма больше максимальной для Онлайн-оплаты, то меняем тип оплаты на "Счёт"
                    [
                        utils.isConditionTrue(['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
                            250000, (total, max) => total > max),
                        {
                            yes: [
                                utils.set(['account', 'orders', 'currentOrder', 'localChanges',
                                    'selectedPaymentTypeId'], 1)
                            ],
                            no: []
                        }
                    ]
                ],
                false:[
                    ...saveFilterValues
                ]
            }
        ],
        customOrder.unsetFilterValuesChanged
    ],
    saveFilterValues: [
        ...saveFilterValues
    ]
};



// WEBPACK FOOTER //
// ./signals/account/editable-order.js